export default __webpack_public_path__ + "static/media/BrainElectrophysiologyLab.fccbc9a2.webp";